/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

export function getTid(file, suffix, prefix) {
	return `${prefix || 'mui'}-${file}${suffix ? `-${suffix}` : ''}`;
}
